import React from 'react';
import {OfferFormSelectionProvider, OfferRequest, OfferRequestPartial} from "../OfferForm";
import styles from "../OfferForm.module.css";
import {CustomInputField} from "../../../../../elements/customInputField/CustomInputField";
import {ValidationResult} from "../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator, UrlValidator} from "../../../../../elements/validator/Validator";
import {Section} from "../../../../../elements/section/Section";
import {ValidatedInputField} from "../../../../../elements/validator/component/ValidatedInputField";
import {ValidatedTextAreaField} from "../../../../../elements/validator/component/ValidatedTextAreaField";
import {useAppSelector} from "../../../../../../app/hooks";
import {CustomInputDateField} from "../../../../../elements/customInputDateField/CustomInputDateField";

interface Props<T> {
    getMessage: (s: any) => any;
    updateRequest: (update: OfferRequestPartial) => void;
    selectionProvider: OfferFormSelectionProvider;
    updateValidationStatus: (status: ValidationResult<T>) => void;
}

export const GeneralOfferInformation = <T extends OfferRequest>({
                                                                    getMessage,
                                                                    updateRequest,
                                                                    selectionProvider,
                                                                    updateValidationStatus,
                                                                }: Props<T>) => {

    const publicId = useAppSelector(selectionProvider.publicId)

    return <Section title={"General Information"}>
        <div className={styles.fieldsLine}>
            <CustomInputField
                readOnly={true}
                isRequired={true}
                title={"Public Offer ID"}
                value={publicId}
                placeholder={"Offer ID will be generated automatically."}
                setValue={() => 123}
            />
            <ValidatedInputField<string, T>
                onChange={(v) => updateRequest({title: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'title'}
                selector={selectionProvider.title}
                validator={NotEmptyStringValidator}
                label={'Title'}
                placeholder={"Offer title"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLine}>
            <ValidatedTextAreaField<string, T>
                onChange={(v) => updateRequest({description: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'description'}
                selector={selectionProvider.description}
                validator={NotEmptyStringValidator}
                label={'Description'}
                maxLength={520}
                placeholder={"Offer description"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <ValidatedInputField<string, T>
                required={true}
                onChange={(v) => updateRequest({make: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'make'}
                selector={selectionProvider.make}
                validator={NotEmptyStringValidator}
                label={'Make'}
                placeholder={"e.g., BMW, or * for all makes"}
                getMessage={getMessage}
            />
            <ValidatedInputField<string, T>
                required={true}
                onChange={(v) => updateRequest({model: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'model'}
                selector={selectionProvider.model}
                validator={NotEmptyStringValidator}
                label={'Model'}
                placeholder={"e.g., M3, or * for all models"}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <ValidatedInputField<string, T>
                required={true}
                onChange={(v) => updateRequest({redirectUrl: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'redirectUrl'}
                selector={selectionProvider.redirectUrl}
                validator={UrlValidator}
                label={'Redirect URL'}
                getMessage={getMessage}
            />
            <ValidatedInputField<string, T>
                required={true}
                onChange={(v) => updateRequest({imageUrl: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'imageUrl'}
                selector={selectionProvider.imageUrl}
                validator={UrlValidator}
                label={'Image URL'}
                getMessage={getMessage}
            />
        </div>
        <div className={styles.fieldsLineWithMargin}>
            <CustomInputDateField
                title={"Start Date"}
                valueSelector={selectionProvider.startDate}
                updateValue={(v) => updateRequest({startDate: v})}
            />
            <CustomInputDateField
                title={"End Date"}
                valueSelector={selectionProvider.endDate}
                updateValue={(v) => updateRequest({endDate: v})}
            />
        </div>
    </Section>
}
